module.exports = __webpack_public_path__ + "static/media/iconExplainer2.211a0ed7.gif";